import Apiservice from '../api.service';
import {API_URL} from '../../../common/config.js'

const apiService = Apiservice;


export default class DashboardService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}`;
    }

    getLibraryStat() {
        let url = `${this.#api}user/library/stats`;
        return apiService.get(url);
    }

    getReturnAndIssueTrend(type = 'daily') {
        let url = `${this.#api}user/library/return-and-issue/trend/${type}`;
        return apiService.get(url);
    }
}